import api from "../api";
import {
  register,
  profile,
  Config,
  menu,
  stock,
  PlaceOrder_endpoint,
  check_endpoint,
  ForgetPassward_endpoint,
  Three_endpoint,
  addToCart_endpoint,
  glb_endpoint,
  glbSizeList_endpoint,
  country_endpoint,
  enquery_endpoint,
  Fiter_endpoint,
  productStyle_endpoint,
  blog_endpoint,
  offer,
  review,
  teamOrder,
  coupon,
  Save
} from "../api_endpoints";
const { REGISTER_API, LOGIN_API, LOGOUT_API } = register;
const { blog_API,blogDetails_API } = blog_endpoint;
const { OFFER_API } = offer;
const { review_API , submitReview_api} = review;
const { Filter_API,HomeFilter_API } = Fiter_endpoint;
const {
  UPDATEPROILE_API,
  PROILE_API,
  IMAGEUPDATE_API,
  GETUSER_API,
  DELETEUSER_API,
  UPDATEUSER_API,
  ADDUSER_API,
  
} = profile;
const{ fetchingCoupon,applyCoupon,getCouponAndDelivery}=coupon
const { CONFIG_API } = Config;
const { SAVE_API,GETSAVE_API } = Save;
const { enquery_API } = enquery_endpoint;
const { country_API } = country_endpoint;
const { MENU_API, MENUSLUG_API, product_API, productDetails_API,allProduct_API,ProductLevel_API,allEvent_API } = menu;
const { STOCK_API } = stock;
const { PlaceOrder_API, PaymentAdd_API, VerifyPayment_API,OrderList_API,OrderDetails_API,GetPaymentKey_API ,GetPaymentVerify_API} =
  PlaceOrder_endpoint;
const { coupon_API } = check_endpoint;
const {forgetPassward_API} = ForgetPassward_endpoint;
const {Three_API} = Three_endpoint;
const {addToCart_API,addToCartGLB_API,updateCart_API,removeCart_API,getCart_API,updateCartQuantity_API} = addToCart_endpoint;
const {Glb_API,OnlyGlb_API} = glb_endpoint;
const {sizeList_API} = glbSizeList_endpoint;
const {productStyle_API} = productStyle_endpoint;
const {teamProductsFilter,teamProductsList,teamFilteredProducts}=teamOrder

// In your ProductAPI.js file, add this function:
export const saveDesign = async (formData, token) => {
  try {
    const response = await api.post(SAVE_API,formData,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // const result = await response.json();
    return response;
  } catch (error) {
    console.error("Save design error:", error);
    return {
      success: false,
      message: "Failed to save design",
    };
  }
};

export const getsaveDesign = async (formData, token) => {
  try {
    const response = await api.post(GETSAVE_API,{},{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // const result = await response.json();
    return response;
  } catch (error) {
    console.error("Save design error:", error);
    return {
      success: false,
      message: "Failed to save design",
    };
  }
};

export const ProductLevel_Api = async () => {
  let result = [];
  try {
    const response = await api.post(ProductLevel_API);
    console.log("ProductLevel : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const blog_Api = async () => {
  let result = [];
  try {
    const response = await api.get(blog_API);
    console.log("blog_API : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};
export const allEvent_Api = async () => {
  let result = [];
  try {
    const response = await api.get(allEvent_API);
    console.log("blog_API : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};
export const offer_Api = async () => {
  let result = [];
  try {
    const response = await api.get(OFFER_API);
    console.log("blog_API : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const review_Api = async () => {
  let result = [];
  try {
    const response = await api.get(review_API);
    console.log("blog_API : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const blogDetails_Api = async (slug) => {
  let result = [];
  try {
    const response = await api.get(`${blogDetails_API}?slug=${slug}`);
    console.log("blog_API : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const productStyle_Api = async () => {
  let result = [];
  try {
    const response = await api.get(productStyle_API);
    console.log("productStyle Api : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const config_Api = async () => {
  let result = [];
  try {
    const response = await api.post(CONFIG_API);
    console.log("config : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const updateCartQuantityAPI = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(updateCartQuantity_API,data,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    console.log("config : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const enquery_Api = async (data) => {
  let result = [];
  try {
    const response = await api.post(enquery_API,data);
    console.log("config : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const get_register = async (data) => {
  let result = [];
  try {
    const response = await api.post(REGISTER_API, data);
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};
export const get_login = async (data) => {
  let result = [];
  try {
    console.log("data : ", data);
    const response = await api.post(LOGIN_API, data);
    console.log("Login : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const get_logout = async (token) => {
  let result = [];
  try {
    const response = await api.post(
      LOGOUT_API,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Logout : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const updateProfile = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(UPDATEPROILE_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const getProfile = async (token) => {
  let result = [];
  try {
    const response = await api.post(
      PROILE_API,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const updateImage = async (data, token) => {
  let result = [];
  try {
    console.log("data : ", data);
    const response = await api.post(IMAGEUPDATE_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const menuSection = async () => {
  let result = [];
  try {
    const response = await api.post(MENU_API, {});
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const menuSlugSection = async (data) => {
  let result = [];
  try {
    const response = await api.post(MENUSLUG_API, data);
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const productApi = async (menuSlug,categorySlug) => {
  let result = [];
  try {
   const response = await api.get(`${product_API}?menuSlug=${menuSlug}&categorySlug=${categorySlug}`);
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const productDetails = async (slug) => {
  let result = [];
  try {
    const response = await api.get(`${productDetails_API}?slug=${slug}`);
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const allProductDetails = async (categoryName) => {
  let result = [];
  try {
    const response = await api.get(`${allProduct_API}?categoryName=${categoryName}`);
    console.log("All Product Response:", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const filterApi = async (menuSlug,categorySlug,filter) => {
  let result = [];
  try {
    const response = await api.get(`${Filter_API}?menuSlug=${menuSlug}&categorySlug=${categorySlug}&filter=${filter}`);
    console.log("All Product Response:", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};
export const homefilterApi = async (categorySlug) => {
  let result = [];
  try {
    const response = await api.get(`${HomeFilter_API}?categoryName=${categorySlug}`);
    console.log("All Product Response:", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};


export const stockCheck = async (data) => {
  let result = [];
  try {
    const response = await api.post(STOCK_API, data);
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const addUser = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(ADDUSER_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const updateUser = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(UPDATEUSER_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const deleteUser = async (data, token) => {
  let result = [];
  try {
    const response = await api.post(DELETEUSER_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const getUser = async (token) => {
  let result = [];
  try {
    const response = await api.post(
      GETUSER_API,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("register : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const PlaceOrder = async (data, token) => {
  let result = [];
  try {
    console.log(">>>>>>>saifuddin<<<<<<<<<<<");
    const response = await api.post(PlaceOrder_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    result = response.data;
    return result;
  } catch (error) {
    console.log("..........");
  }
};

export const PaymentAdd = async (data, token) => {
  let result = [];
  try {
    console.log("data : ", data);
    const response = await api.post(PaymentAdd_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........");
  }
};

export const orderValidate = async (data, token) => {
  let result = [];
  try {
    console.log("data : ", data);
    const response = await api.post(VerifyPayment_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........");
  }
};

export const Coupon_data = async (data, token) => {
  let result = [];
  console.log("token : ",token)
  try {
    console.log(">>>>>>>saifuddin<<<<<<<<<<<");
    const response = await api.post(coupon_API, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Coupon Api : ", response);
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_login_API_ERROR..........");
  }
};

export const orderList = async (token) => {
  let result = [];
  try {
    const response = await api.post(
      OrderList_API,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........");
  }
};

export const particularOrder = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(
      OrderDetails_API,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........");
  }
};

export const forgetPasswardChange = async (data) => {
  let result = [];
  try {
    const response = await api.post(
      forgetPassward_API,
      data
    );
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........");
  }
};

export const export_3d = async (data,token) => {
  let result = [];
  console.log("token : ",token)
  try {
    const response = await api.post(Three_API,data,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("data : ",data)
    console.log("config : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const get_glbFile = async (data) => {
  let result = [];
  try {
    const response = await api.post(Glb_API,data);
    console.log("data : ",data)
    console.log("config : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const addToCart = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(addToCart_API,data,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("data : ",data)
    console.log("config : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

// export const addToCartGLB = async (data,token) => {
//   let result = [];
//   try {
//     const response = await api.post(addToCartGLB_API,data,{
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     console.log("data : ",data)
//     console.log("config : ", response);
//     result = response.data;
//   } catch (error) {
//     console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
//   }
//   return result;
// };

export const updateCart = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(updateCart_API,data,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("data : ",data)
    console.log("config : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const removeCartItem = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(removeCart_API,data,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("data : ",data)
    console.log("config : ", response);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const glbGetSize = async () => {
  let result = [];
  try {
    const response = await api.post(sizeList_API);
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const getCart = async (token) => {
  let result = [];
  try {
    const response = await api.post(getCart_API,{},{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};

export const get_paymentKey = async (data,token) => {
  let result = [];
  try {
    const response = await api.post(
      GetPaymentKey_API,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........");
  }
};

export const get_paymentVerify = async (paymentIntentId) => {
  let result = [];
  try {
    const response = await api.post(
      GetPaymentKey_API,
      {paymentIntentId},
    );
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........");
  }
};

export const get_countryList = async () => {
  let result = [];
  try {
    const response = await api.post(
      country_API,
      {},
    );
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........");
  }
};

export const particular_Glb = async (data) => {
  let result = [];
  try {
    const response = await api.post(
      OnlyGlb_API,
      data,
    );
    result = response.data;
    return result;
  } catch (error) {
    console.log("GET_logOut_API_ERROR..........", error);
  }
};


export const getAllTeamProductsFilters=async()=>{

  try {
    const response= await api.get(teamProductsFilter)
    console.log(response);
    
    return response

  } catch (error) {
    console.log(error);
    throw error
  }
}

export const getAllTeamProductsList=async({limit,page})=>{
    try {

    const response= await api.get(`${teamProductsList}?limit=12&page=${page}`)
    console.log(response);
    
    return response

  } catch (error) {
    console.log(error);
    throw error
  }
}
export const getAllTeamProductsListFiltered = async ({
  menuId,
  categoryId,
  colorId
}) => {
  try {
    const params = new URLSearchParams()

    if (menuId) params.append('menu_id[]', menuId)
    if (categoryId) params.append('category_id[]', categoryId)
    if (colorId) params.append('color_id[]', colorId)

    const queryString = params.toString()
    const url = queryString
      ? `${teamFilteredProducts}&${queryString}`
      : teamFilteredProducts

    const response = await api.get(url)
    return response
  } catch (error) {
    console.log(error)
    throw error
  }
}


export const submitReview = async (data,token) => {
  let result = [];
  console.log(data);
  
  try {
    const response = await api.post(submitReview_api,data,{
      headers: {
        Authorization: `Bearer ${token}`,
         "ContentType": "multipart/form-data" 
      },
    });
    result = response.data;
  } catch (error) {
    console.error("GET_ALL_PRODUCT_API_ERROR..........", error);
  }
  return result;
};


export const getCoupons=async(token)=>{
    try {

    const response= await api.get(fetchingCoupon,{
      headers: {
        Authorization: `Bearer ${token}`,
      
      },
    })
    console.log(response);
    
    return response

  } catch (error) {
    console.log(error);
    throw error
  }
}


export const applyCouponApi=async(data,token)=>{
  try{
    const res=await api.post(applyCoupon,data,{
         headers: {
        Authorization: `Bearer ${token}`,
      
      },
    })
    return res

  }catch(err){
 throw err
  }
}

export const getCouponAndDeliveryApi=async(token,quantity)=>{
  try {
    const response=await api.post(getCouponAndDelivery,{quantity},{
        headers: {
        Authorization: `Bearer ${token}`,
      
      },
    })
    return response
    
  } catch (error) {
    throw error
    
  }
}